// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nn-1";
export var messageSideRight = "_nn-2";
export var subscribeToBackInStockBubbleContainer = "_nn-0";